<div class="card card-nc" ng-show="hasEntitlement('SEARCH_VISITOR')">
  <div class="card-heading">
    <div class="card-title search-header">Visitor Profiles</div>
  </div>
  <div class="card-body">
    <form #searchForm="ngForm" name="visitorCardSearchForm" novalidate>
      <div class="form-group row" style="margin-bottom: 0px;">
        <div class="col-md-11">
          <input
            name="firstParameter"
            id="firstParameter"
            [(ngModel)]="firstParameter"
            class="form-control input-sm searhBoxheight"
            type="text"
            placeholder="Search card Id, chip account"
          />
        </div>
        <div class="col-md-1">
          <button
            type="submit"
            (click)="submit()"
            class="form-group btn btn-nc pull-right"
          >
            SEARCH<i [ngClass]="{ 'fa fa-spinner fa-spin': processing }"></i>
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
<div *ngIf="hasEntitlement('SEARCH_VISITOR')">
  <div *ngIf="processing">
    <div class="row justify-content-center">
      <div class="col-1">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
  </div>
  <div *ngIf="noSearchParameters">
    <div class="searchResults">
      <div class="row searchResultsRow">Please enter search criteria.</div>
    </div>
  </div>
  <div *ngIf="visitorCardStubs !== null && visitorCardStubs.length === 0">
    <div class="searchResults">
      <div class="row searchResultsRow">No results found.</div>
    </div>
  </div>
  <div
    *ngIf="
      !processing &&
      recentCardStubs !== null &&
      recentCardStubs.length > 0 &&
      visitorCardStubs === null
    "
  >
    <app-visitor-card-search-results [visitorCardStubs]="recentCardStubs">
    </app-visitor-card-search-results>
  </div>
  <div
    *ngIf="
      !processing && visitorCardStubs !== null && visitorCardStubs.length > 0
    "
  >
    <app-visitor-card-search-results [visitorCardStubs]="visitorCardStubs">
    </app-visitor-card-search-results>
  </div>
</div>
<div
  class="text-error"
  style="color:RED"
  *ngIf="!hasEntitlement('SEARCH_VISITOR')"
>
  You do not have permission to view this page
</div>
